import Vue from 'vue';
import fb from '../../firebaseConfig.js';
import {
  CURRENT_USER,
  USER_INFO,
  IS_AUTHENTICATED,
  SET_CURRENT_USER,
  SET_USER_INFO
} from '../constants';
import { categories, subCategories } from '../../configs';

export default {
  namespaced: true,
  state: {
    [IS_AUTHENTICATED]: false,
    [CURRENT_USER]: null,
    [USER_INFO]: null
    // [UPDATE_CATEGORIES_LOADING]: false,
    // [UPDATE_CATEGORIES_SUCCESS]: null,
    // [UPDATE_CATEGORIES_ERROR]: null,
    // [UPDATE_CURRENCIES_LOADING]: false,
    // [UPDATE_CURRENCIES_SUCCESS]: null,
    // [UPDATE_CURRENCIES_ERROR]: null
  },
  actions: {
    clearData({ commit }) {
      commit(SET_CURRENT_USER, null);
      commit(SET_USER_INFO, null);
    },
    // async updateCategories({ commit, state, dispatch }, { categories, subcategories }) {
    //   try {
    //     commit(SET_UPDATE_CATEGORIES_LOADING, true);
    //     commit(SET_UPDATE_CATEGORIES_ERROR, null);
    //     commit(SET_UPDATE_CATEGORIES_SUCCESS, null);
    //     fb.users.doc(state[CURRENT_USER].uid).update({
    //       'hasConfigured.categories': true,
    //       categories,
    //       subcategories
    //     });
    //     dispatch('fetchUserProfile');
    //     setTimeout(() => {
    //       commit(SET_UPDATE_CATEGORIES_LOADING, false);
    //       commit(SET_UPDATE_CATEGORIES_SUCCESS, true);
    //       commit(SET_UPDATE_CATEGORIES_ERROR, null);
    //     }, 250);
    //   } catch (error) {
    //     commit(SET_UPDATE_CATEGORIES_LOADING, false);
    //     commit(SET_UPDATE_CATEGORIES_ERROR, error.message);
    //     commit(SET_UPDATE_CATEGORIES_SUCCESS, null);
    //   }
    // },
    // async updateCurrencies({ commit, state, dispatch }, { currencies, defaultCurrency }) {
    //   try {
    //     commit(SET_UPDATE_CURRENCIES_LOADING, true);
    //     commit(SET_UPDATE_CURRENCIES_ERROR, null);
    //     commit(SET_UPDATE_CURRENCIES_SUCCESS, null);
    //     fb.users.doc(state[CURRENT_USER].uid).update({
    //       'hasConfigured.currencies': true,
    //       defaultCurrency,
    //       currencies
    //     });
    //     dispatch('fetchUserProfile');
    //     setTimeout(() => {
    //       commit(SET_UPDATE_CURRENCIES_LOADING, false);
    //       commit(SET_UPDATE_CURRENCIES_SUCCESS, true);
    //       commit(SET_UPDATE_CURRENCIES_ERROR, null);
    //     }, 250);
    //   } catch (error) {
    //     commit(SET_UPDATE_CURRENCIES_LOADING, false);
    //     commit(SET_UPDATE_CURRENCIES_ERROR, error.message);
    //     commit(SET_UPDATE_CURRENCIES_SUCCESS, null);
    //   }
    // },
    async fetchUserProfile({ commit, state }) {
      try {
        const response = await fb.users.doc(state[CURRENT_USER].uid).get();
        commit(SET_USER_INFO, response.data());
        return response;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while fetching your info.',
          description: error.message,
          placement: 'bottomLeft'
        });
        commit(SET_USER_INFO, {});
        throw error;
      }
    },
    async login({}, { email, password }) {
      try {
        return await fb.auth.signInWithEmailAndPassword(email, password);
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while logging in.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async signup({}, { email, password, firstName, lastName }) {
      try {
        const authRes = await fb.auth.createUserWithEmailAndPassword(email, password);
        if (authRes) {
          const id = authRes.user.uid;
          await fb.users.doc(id).set({
            firstName,
            lastName,
            hasConfigured: {
              categories: false,
              currencies: false,
              tags: false
            },
            initials: firstName.slice(0, 1).toUpperCase() + lastName.slice(0, 1).toUpperCase()
          });
          const categoriesBatch = fb.db.batch();
          categories.forEach(category => {
            const docRef = fb.users
              .doc(id)
              .collection('categories')
              .doc(category.id.toString());
            categoriesBatch.set(docRef, {
              id: 'users/' + id + '/categories/' + category.id,
              color: category.color,
              name: category.name
            });
          });
          await categoriesBatch.commit();

          categories.forEach(async category => {
            const subcategoriesBatch = fb.db.batch();
            subCategories.forEach((subcategory, index) => {
              if (subcategory.parentId === category.id) {
                const docRef = fb.users
                  .doc(id)
                  .collection('categories')
                  .doc(category.id.toString())
                  .collection('subcategories')
                  .doc(index.toString());
                subcategoriesBatch.set(docRef, {
                  id: 'users/' + id + '/categories/' + category.id + '/subcategories/' + index,
                  ...subcategory,
                  parentId: 'users/' + id + '/categories/' + category.id
                });
              }
            });
            await subcategoriesBatch.commit();
          });
          return authRes;
        }
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong with registration.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async logout({ dispatch }) {
      try {
        dispatch('clearData');
        await fb.auth.signOut();
        return location.reload();
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while logging out.',
          description: err,
          placement: 'bottomLeft'
        });
        throw error;
      }
    }
  },
  mutations: {
    [SET_CURRENT_USER]: (s, d) => {
      s[CURRENT_USER] = d;
      s[IS_AUTHENTICATED] = !!d;
    },
    [SET_USER_INFO]: (s, d) => (s[USER_INFO] = d)
    // [SET_LOGIN_LOADING]: (s, d) => (s[LOGIN_LOADING] = d),
    // [SET_LOGIN_SUCCESS]: (s, d) => (s[LOGIN_SUCCESS] = d),
    // [SET_LOGIN_ERROR]: (s, d) => (s[LOGIN_ERROR] = d)

    // [SET_UPDATE_CATEGORIES_LOADING]: (s, d) => (s[UPDATE_CATEGORIES_LOADING] = d),
    // [SET_UPDATE_CATEGORIES_SUCCESS]: (s, d) => (s[UPDATE_CATEGORIES_SUCCESS] = d),
    // [SET_UPDATE_CATEGORIES_ERROR]: (s, d) => (s[UPDATE_CATEGORIES_ERROR] = d),
    // [SET_UPDATE_CURRENCIES_LOADING]: (s, d) => (s[UPDATE_CURRENCIES_LOADING] = d),
    // [SET_UPDATE_CURRENCIES_SUCCESS]: (s, d) => (s[UPDATE_CURRENCIES_SUCCESS] = d),
    // [SET_UPDATE_CURRENCIES_ERROR]: (s, d) => (s[UPDATE_CURRENCIES_ERROR] = d)
  }
};
